import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Layout } from "../../../ui/layout"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import TextArea from "../../../ui/molecules/textArea"
import { Calendar } from "../../../ui/molecules/calendar"
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static"
import { TipoOperatoreDemeter } from "../../../utils"
import { MadfarmInput } from "../../../ui/molecules/input/newInput"
import { ProtocolSearch } from "../../../ui/molecules/ProtocolSearch"
import { CustomAccordion } from "../../../ui/molecules/accordion"
import { ArrowLeftIcon } from "../../../ui/icons/arrow-left"
import { SuccessPopup } from "../../../ui/organisms/successPopup"
import { GetAllInspectionVisit } from "../../incarichi/slice"
import { resetUpdateStatus, setUpdateClientType, setUpdateCodexNote, setUpdateCompanyType, setUpdateDemeterNote, setUpdateEdingDate, setUpdatePrivacyProtocol, setUpdateProcessingType, setUpdateStake, setUpdateStartingDate, setUpdateTerzeParti, setUpdateVisitId, setUpdateYear, UpdateDemeter } from "./slice"

export function EditCertificazioneDemeter() {
    const navigate = useNavigate()
    const sessionState = useAppSelector(state => state.session)
    const [visitOptions, setVisitOptions] = useState<{ value: string; label: string }[]>([]);
    const dispatch = useAppDispatch()
    const assignmentState = useAppSelector(state => state.assignment)
    const demeter = useAppSelector(state => state.demeter)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const [expanded, setExpanded] = useState<string>('panel1')
    const successHandledRef = useRef(false)
    const selectedCustomerId = sessionState.selected.customerId || demeter.updateCertDemeter.customerId

    const handleToggleAccordion = (panel: string) => {
        setExpanded(prev => (prev === panel ? '' : panel))
    }

    useEffect(() => {
        if (selectedCustomerId) {
            dispatch(GetAllInspectionVisit({
                itemsPerPage: 0,
                page: 0,
                customerId: selectedCustomerId.toString()
            }))
        }
    }, [selectedCustomerId])

    useEffect(() => {
        if (assignmentState.getAllInspectionVisitStatus === 'successfully') {
            const visits = assignmentState.getAllInspectionVisitResponse?.data || [];
            const options = visits.map((visit) => ({
                value: String(visit.id),
                label: new Date(visit.effectiveVisitDate).toLocaleDateString('it-IT') + " " + (visit.reportProtocolInfo ? visit.reportProtocolInfo : ''),
            }));
            setVisitOptions(options);
        }
    }, [assignmentState.getAllInspectionVisitStatus]);

    useEffect(() => {
        if (demeter.demeterUpdateStatus === 'successfully') {
            successHandledRef.current = false
            setShowSuccess(true)
        }
    }, [demeter.demeterUpdateStatus])

    const handleSuccessClose = () => {
        if (successHandledRef.current) {
            return
        }

        successHandledRef.current = true
        setShowSuccess(false)
        dispatch(resetUpdateStatus())
        navigate('/gestioneDemeter')
    }


    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Gestione Demeter', 'Modifica Demeter']}
            noPaddingLat
            headerLabel="Gestione Demeter"
            headerIcon={
                <ArrowLeftIcon onClick={() => navigate('/gestioneDemeter')} color={"#F2F7F7"} size={0} />
            }
            headerChildren={
                <div className="flex items-center h-full w-full justify-end gap-2">
                    <ButtonComponent
                        iconPosition='off'
                        variant='solid'
                        color='orange'
                        size='sm'
                        label='Modifica'
                        onClick={() => {
                            if (demeter.idSelectedCert) {
                                dispatch(UpdateDemeter({ body: demeter.updateCertDemeter, id: demeter.idSelectedCert }))
                            }
                        }}
                    />
                </div>
            }
        >
            {
                showSuccess &&
                <div className="px-6 pt-3 pb-1 flex flex-col gap-2">
                    <SuccessPopup
                        active={showSuccess}
                        message="Dati salvati correttamente."
                        onClose={handleSuccessClose}
                    />
                </div>
            }
            <div className="p-6 flex flex-col gap-6">
                <CustomAccordion
                    id="panel1"
                    title={<span className="text-uppercase text-white label-input">Dati Demeter</span>}
                    expanded={expanded === 'panel1'}
                    onChange={() => handleToggleAccordion('panel1')}
                    detailsClassName="flex flex-col gap-4"
                >
                    <div className="grid grid-cols-1 gap-4">
                        <MadfarmStaticSelect
                            label="Controllo (elenco controlli)"
                            placeholder={'Visite ispettive'}
                            options={visitOptions}
                            value={demeter.updateCertDemeter.inspectionVisitId}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setUpdateVisitId(newValue))
                            }}
                            noOptionsMessage={"Nessun risultato trovato"}
                        />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <MadfarmInput
                            label={'Anno'}
                            placeholder="Anno"
                            defaultValue={demeter.updateCertDemeter.year}
                            onChangeText={(text) => dispatch(setUpdateYear(text))}
                        />
                        <Calendar
                            label={'Data Inizio'}
                            selected={demeter.updateCertDemeter.startingDate}
                            onChange={(date) => dispatch(setUpdateStartingDate(date))}
                        />
                        <Calendar
                            label={'Data Fine'}
                            selected={demeter.updateCertDemeter.endingDate}
                            onChange={(date) => dispatch(setUpdateEdingDate(date))}
                        />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        <MadfarmStaticSelect
                            label="Tipo Operatore"
                            noOptionsMessage="Nessun risultato trovato"
                            placeholder={'Tipo Operatore'}
                            value={demeter.updateCertDemeter.operatorType}
                            options={TipoOperatoreDemeter}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setUpdateClientType(newValue))
                            }}
                        />
                        <MadfarmInput
                            label={'Tipo Azienda'}
                            placeholder="Tipo Azienda"
                            defaultValue={demeter.updateCertDemeter.companyType}
                            onChangeText={(text) => dispatch(setUpdateCompanyType(text))}
                        />
                        <MadfarmInput
                            label={'Quota'}
                            placeholder="Quota"
                            defaultValue={demeter.updateCertDemeter.rate !== undefined ? String(demeter.updateCertDemeter.rate) : undefined}
                            onChangeText={(text) => dispatch(setUpdateStake(text))}
                        />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <MadfarmInput
                            label={'Conto Terzi per Azienda'}
                            placeholder="Conto Terzi per Azienda"
                            defaultValue={demeter.updateCertDemeter.thirdParty}
                            onChangeText={(text) => dispatch(setUpdateTerzeParti(text))}
                        />
                        <MadfarmInput
                            label={'Tipo Lavorazione'}
                            placeholder="Tipo Lavorazione"
                            defaultValue={demeter.updateCertDemeter.processingType}
                            onChangeText={(text) => dispatch(setUpdateProcessingType(text))}
                        />
                    </div>

                    <div className="grid grid-cols-1 gap-4">
                        <ProtocolSearch
                            label="Protocollo Privacy"
                            defaultValue={demeter.updateCertDemeter.privacyProtocolId}
                            type='entry'
                            onSelect={(value) => {
                                dispatch(setUpdatePrivacyProtocol(value))
                            }}
                        />
                    </div>
                </CustomAccordion>

                <CustomAccordion
                    id="panel2"
                    title={<span className="text-uppercase text-white label-input">Note</span>}
                    expanded={expanded === 'panel2'}
                    onChange={() => handleToggleAccordion('panel2')}
                    detailsClassName="flex flex-col gap-4"
                >
                    <div className="grid grid-cols-1 gap-4">
                        <TextArea
                            label="Note Demeter"
                            defaultValue={demeter.updateCertDemeter.demeterNote}
                            onChangeText={(value) => dispatch(setUpdateDemeterNote(value))}
                        />
                    </div>
                    <div className="grid grid-cols-1 gap-4">
                        <TextArea
                            label="Note Codex"
                            defaultValue={demeter.updateCertDemeter.codexNote}
                            onChangeText={(value) => dispatch(setUpdateCodexNote(value))}
                        />
                    </div>
                </CustomAccordion>
            </div>
        </Layout>
    )

}